import React from 'react';
import { Link, Typography } from "@material-ui/core";

const Copyright = () => (
	<Typography variant="body2" color="textSecondary" align="center">
		©
        &nbsp;
		<Link color="inherit" href="https://virtev.net/">
			VIRTEV
		</Link>
        &nbsp;
		{new Date().getFullYear()}.
	</Typography>
);

export default Copyright;
